import styles from './vertical-divider.module.scss';

export const VerticalDivider = () => {
  return <div className={styles.verticalDivider} />;
};
